import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

export const CtaSection = () => (
  <section id="cta" data-testid="cta-section" className="relative overflow-hidden border-y border-[#C5A059]/20 bg-[#0A111E] py-24 sm:py-28">
    <div className="pointer-events-none absolute inset-0 architectural-grid opacity-50" />
    <div className="pointer-events-none absolute -left-24 top-1/2 h-72 w-72 -translate-y-1/2 rounded-full bg-[#C5A059]/10 blur-[100px]" />
    <div className="pointer-events-none absolute -right-24 top-1/2 h-72 w-72 -translate-y-1/2 rounded-full bg-[#C5A059]/10 blur-[100px]" />
    <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
      <Reveal>
        <h2 className="font-serif text-3xl font-light uppercase leading-snug tracking-tight text-white sm:text-5xl">
          Have a Property Project <span className="gold-text-gradient">in Mind?</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-base font-light leading-relaxed text-slate-300 sm:text-lg">
          Tell us what you're looking to achieve and we'll help you plan the next step.
        </p>
        <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row">
          <button
            data-testid="cta-quote-button"
            onClick={() => scrollToId("#contact")}
            className="bg-[#C5A059] px-10 py-4 text-xs font-bold uppercase tracking-[0.25em] text-[#050B14] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#E6CA65]"
          >
            Request a Quote
          </button>
          <button
            data-testid="cta-contact-button"
            onClick={() => scrollToId("#contact")}
            className="border border-white/30 px-10 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-white transition-all duration-300 hover:-translate-y-0.5 hover:border-[#C5A059] hover:text-[#C5A059]"
          >
            Contact Tyrell
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
